export { requestGame, isLineBrowser } from './gameLaunch';
